import { apiSauceInstance } from '../../../services/api'
import { EdgesPage } from '@elentari/core/types'
import { makeRepository } from '@elentari/core/utils/makeRepository'
import { ParsedQs } from 'qs'
import { paginationParams } from '../../../utils/paginationQueryParams'
import { CentroCusto, CentroCustoDetail, StatusCentroCusto } from '../types'

const mapQueryParams = (params: ParsedQs): ParsedQs => {
  const { limit, ...rest } = params

  return {
    ...paginationParams(rest),
    limit: limit || '10'
  }
}

export const centroCustoRepository = makeRepository<
  EdgesPage<CentroCustoDetail>,
  CentroCusto,
  CentroCustoDetail,
  string
>({ resource: 'centros-custo', mapQueryParams }, apiSauceInstance)

export const alterarStatus = async (id: string, status: StatusCentroCusto) => {
  return apiSauceInstance.patch<
    { status: StatusCentroCusto },
    { message: string; error: any }
  >(`/centros-custo/${id}/alterar-status/`, { status })
}
